import $ from 'jquery';
import { validateEmail, validatePhone, request } from './utility';

$('#send-contact').on('click', function (e) {
  e.preventDefault();
  var data = $('form[name="contact"]').serializeArray();
  var isCheck = true;
  data.map(function (item) {
    switch (true) {
      case item.name === 'name' && !item.value:
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'email' && !validateEmail(item.value):
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'phone' && !validatePhone(item.value):
        $('input[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      case item.name === 'content' && !item.value:
        $('textarea[name="' + item.name + '"]').addClass('error');
        isCheck = false;
        break;
      default:
        break;
    }
  });
  if (isCheck) {
    $('form[name="contact"] input').addClass('success');
    $('form[name="contact"] textarea').addClass('success');
    $('form[name="contact"] button').addClass('loading');
    $('form[name="contact"] button').attr('disabled', true);
    $.when(request('POST', '../../ajax/contactForm.php', data)).done(
      function (result) {
        if (result && result.status) {
          $('.send-contact--thong-bao').addClass('success');
          setTimeout(function () {
            $('form[name="contact"]').get(0).reset();
            $('form[name="contact"] button').removeClass('loading');
            $('form[name="contact"] button').attr('disabled', false);
            $('.send-contact--thong-bao').removeClass('error success');
          }, 2000);
        }
      },
    );
  }
  setTimeout(function () {
    $('form[name="contact"] input').removeClass('error success');
    $('form[name="contact"] textarea').removeClass('error success');
  }, 2000);
});
